import React from "react";
import { useTrendingSearches } from "./TrendingSearches.hook";
import "./TrendingSearches.less";

interface TrendingSearchesProps {
	className?: string;
}

export const TrendingSearches: React.FC<TrendingSearchesProps> = ({ 
	className = ""
}) => {
	const { loading, data, error, hasRecommendations } = useTrendingSearches();

	// Don't show anything while loading or if there's an error
	if (loading || error) {
		return null;
	}

	// Only show if we have recommendations
	if (!hasRecommendations || !data) {
		return null;
	}

	return (
		<div className={`trending-searches-container ${className}`}>
			<h3 className="trending-searches-title">Búsquedas recomendadas</h3>
			<div 
				className="trending-searches-widget"
				dangerouslySetInnerHTML={{ __html: data.widgetHtml }}
			/>
		</div>
	);
};
